module.exports = __webpack_public_path__ + "static/media/14UNEP12.780cc918.jpg";